<!--
 * @Author: baiwei
 * @Date: 2020-03-25 11:19:35
 * @LastEditors: fengzhongmei 996180799@qq.com
 * @LastEditTime: 2022-09-28 10:19:03
 * @Description: 描述
 * @Copyright: Cloud-Star. Co. Ltd. All rights reserved.
 -->
<template>
    <div class="card">
        <div class="title">{{$t('费用信息')}}</div>
        <div v-for="(statistics,index) in statistics"
             :key="index"
             class="carditem">
            <div class="accountItem">
                <!-- v-if="hasPermission('CC0201')&&hasPermission('CC01')&&hasPermission('CA01')" -->
                <span v-if="hasPermission('CA010101')"
                      class="recharge"
                      @click="recharge(statistics.accountId)">{{$t('充值')}}</span>
                <div class="account">
                    <Dropdown trigger="hover"
                              :transfer="true"
                              placement="bottom-start"
                              class="btn-res left">
                        <!-- v-if="hasPermission('CB1710')" -->
                        <Tooltip theme="light"
                                 :disabled="true"
                                 placement="bottom-start"
                                 :transfer="true">
                            <span class="recharge">{{$t('支持产品')}}</span>
                        </Tooltip>

                        <DropdownMenu slot="list">
                            <DropdownItem :name="item.productCode"
                                          v-for="item in statistics.products"
                                          :key="item.productCoded"
                                          class="create-hpc-btn-container-drop-item">
                                {{$t(item.productName)}}
                            </DropdownItem>
                            <div v-if="statistics.products.length === 0"
                                 class="net-no-data">
                                &nbsp;
                                <i class="icon-prompt-1-o"></i>
                                &nbsp;{{$t('暂无数据')}}
                            </div>
                        </DropdownMenu>
                    </Dropdown>
                </div>
                <div class="account"
                     style="float:left;margin-left: 1%;">
                    <span class="span spanW"
                          :title="statistics.entityName||'--'">{{$t('账户名称')}}：{{statistics.entityName||'--'}}</span>
                    <span class="span">{{$t('账户ID')}}：{{statistics.accountId||'--'}}</span>
                    <span class="span">{{$t('状态')}}：<span :style="{color: getColor(statistics.status),'font-size':'12px'}">{{statusName[statistics.status]}}</span></span>
                </div>
            </div>
            <ul class="cost-pack">
                <li>
                    <b class="rc-ellipsis"
                       :title="$isNullOrEmpty(statistics.accountBalance)?'--':$money(statistics.accountBalance)">{{$isNullOrEmpty(statistics.accountBalance)?'--':$money(statistics.accountBalance)}}</b>
                    <span class="rc-ellipsis"
                          :title="$t('我的现金余额')">{{$t('我的现金余额')}}</span>
                </li>
                <li>
                    <div style="display: flex;align-items: center;">
                        <b class="rc-ellipsis"
                           :title="$isNullOrEmpty(statistics.creditLine)?'--':$money(statistics.creditLine)">
                            {{$isNullOrEmpty(statistics.creditLine)?'--':$money(statistics.creditLine)}}
                        </b>
                        <Tooltip v-if="statistics.creditLineDt && statistics.creditLineDt !== 'unlimited' && statistics.creditLine"
                                 placement="top"
                                 transfer
                                 :content="`${$t('信用余额将于')} ${statistics.creditLineDt} ${$t('到期！')}`">
                            <i class="icon-template-timing-o"
                               style="font-size: 12px;color:#2d8cf0;line-height: 18px;"></i>
                        </Tooltip>
                    </div>
                    <span class="rc-ellipsis"
                          :title="$t('信用余额')">{{$t('信用余额')}}</span>
                </li>
                <li v-if="hasPermission('CC0203')"
                    class="on"
                    @click="goCouponordinary('cash')">
                    <b class="rc-ellipsis"
                       :title="$isNullOrEmpty(statistics.cashAmount)?'--':$money(statistics.cashAmount)">{{$isNullOrEmpty(statistics.cashAmount)?'--':$money(statistics.cashAmount)}}</b>
                    <span class="rc-ellipsis"
                          :title="$t('充值现金券余额')">{{$t('充值现金券余额')}}</span>
                </li>
                <li v-if="hasPermission('CC0204')"
                    class="on"
                    @click="goCouponordinary('discount')">
                    <b class="rc-ellipsis"
                       :title="$isNullOrEmpty(statistics.deductCashAmount)?'--':$money(statistics.deductCashAmount)">{{$isNullOrEmpty(statistics.deductCashAmount)?'--':$money(statistics.deductCashAmount)}}</b>
                    <span class="rc-ellipsis"
                          :title="$t('抵扣现金券余额')">{{$t('抵扣现金券余额')}}</span>
                </li>
                <li style="width:30%;"
                    class="on"
                    @click="goCouponordinary('coupon')">
                    <div class="rc-ellipsis"
                         style="font-size: 12px; color: #808080;"><b style="color:#333;display: inline-block;">&nbsp;{{$isNullOrEmpty(statistics.couponCount)?'--':statistics.couponCount}}</b> {{$t('张')}}（{{$t('7日内到期')}}<small style="font-size: 12px; color: #ff6a01;">{{statistics.expireCouponCount || 0}}</small>{{$t('张')}}）</div>
                    <span class="rc-ellipsis"
                          :title="$t('优惠券')">{{$t('优惠券')}}</span>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import API from '@/service/api.js'
export default {
    name: 'cloudproduct',
    props: {
        statistics: {
            type: Array
        }
    },
    components: {},
    data () {
        return {
            productList: [],
            statusName: {
                normal: '正常',
                freeze: '冻结'
            }
        }
    },
    computed: {
        accountInf () {
            return this.$store.state.user.accountInf.accountInf
        },
        accountInfStatus () {
            const statusName = {
                normal: '正常',
                freeze: '冻结'
            }
            return this.accountInf.status ? `<span style="color: ${this.getColor(this.accountInf.status)}">${statusName[this.accountInf.status]}</span>` : `<span>${'--'}</span>`
        }
    },
    // created () {
    //     this.getProduct()
    // },
    methods: {
        recharge (accountId) {
            this.$router.push({
                path: '/mgt/onlinerecharge',
                query: { accountId }
            })
        },
        goCouponordinary (val) {
            this.$router.push({
                path: '/mgt/couponordinary',
                query: { tabName: val }
            })
        },
        getProduct () {
            const accountId = this.accountInf.id
            this.axios.get(this.urlFormat(API.GET_PRODUCTS_PRODUCT, false, [accountId])).then(res => {
                if (res) {
                    this.productList = res
                }
            })
        }
    }
}
</script>
<style lang="less" scoped>
.card {
    overflow: hidden;
    .recharge {
        float: right;
        padding: 3px 10px;
        background: #1f68b3;
        color: #fff;
        cursor: pointer;
        border-radius: 3px;
    }
    .carditem {
        background: #f5f6f7;
        width: 98%;
        margin: 0 auto;
        padding: 10px 0 5px 0;
        margin-bottom: 10px;
    }
    .accountItem {
        // width: 98%;
        padding: 3px 10px;
        height: 30px;
        font-weight: 600;
        .account {
            float: right;
            margin-right: 10px;
            font-weight: normal;
            .span {
                margin-right: 20px;
                // font-size: 14px;
            }
            .spanW {
                width: 168px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                display: inline-block;
                vertical-align: bottom;
            }
        }
    }
}
.cost-pack {
    display: flex;
    // justify-content: flex-end;
    padding: 5px 10px 15px 10px;
    width: 100%;
    li {
        width: 20%;
        padding-left: 1%;
        b {
            font-size: 16px;
            display: block;
        }
        span {
            display: block;
            line-height: 15px;
            font-size: 12px;
            // padding-left: 3px;
            padding-top: 5px;
        }
    }
    .on {
        cursor: pointer;
    }
}
</style>
